import { Controller } from "stimulus";
import Cookies from "js-cookie";

const COOKIE_NAME = "coinSessionsArray";
const HIDE_MODAL_COOKIE_NAME = "hideAddCoinModal";

export default class extends Controller {
  static values = { coinId: String };
  static targets = ["modal"];

  connect() {
    this._addCoinIdToSessionArray();
    setTimeout(() => {
      this._showModalIfSessionsMoreThenThree();
    }, "3000");
  }

  closeModal() {
    this.modalTarget.classList.remove("lg:tw-block");
    Cookies.set(HIDE_MODAL_COOKIE_NAME, true);
  }

  _addCoinIdToSessionArray() {
    if (this._cookieUndefined() && Cookies.get(HIDE_MODAL_COOKIE_NAME) === undefined) {
      Cookies.set(COOKIE_NAME, JSON.stringify([`${this.coinIdValue}`]));
    } else {
      let coinSessionsArray = JSON.parse(Cookies.get(COOKIE_NAME));
      if (!coinSessionsArray.includes(this.coinIdValue)) {
        coinSessionsArray.push(this.coinIdValue);
        Cookies.set(COOKIE_NAME, JSON.stringify(coinSessionsArray));
      }
    }
  }

  _showModalIfSessionsMoreThenThree() {
    let coinSessionsArray = JSON.parse(Cookies.get(COOKIE_NAME));
    let hideModal = Cookies.get(HIDE_MODAL_COOKIE_NAME);
    if (coinSessionsArray.length >= 3 && hideModal !== "true") {
      gtag('event', 'view_coin_page_portfolio_prompt');
      this.modalTarget.classList.add("lg:tw-block");
      Cookies.remove(COOKIE_NAME);
    }
  }

  _cookieUndefined() {
    return Cookies.get(COOKIE_NAME) === undefined;
  }
}
